/** Privacy Policy page: sidebar active state from hash / scroll. */
(function () {
  const root = document.querySelector('privacy-policy-page');

  if (!root) {
    return;
  }

  const links = Array.from(root.querySelectorAll('.privacy-policy-sidebar__link'));
  const topics = Array.from(root.querySelectorAll('.privacy-policy-page__topic[id]'));

  if (!links.length || !topics.length) {
    return;
  }

  const setActive = id => {
    links.forEach(link => {
      const isActive = link.getAttribute('href') === `#${id}`;
      link.classList.toggle('is-active', isActive);
      link.classList.toggle('active', isActive);
    });
  };

  const firstId = topics[0]?.id;

  if (firstId && !window.location.hash) {
    setActive(firstId);
  } else if (window.location.hash) {
    setActive(window.location.hash.slice(1));
  }

  const mobileToggle = root.querySelector('.privacy-policy-sidebar__mobile-toggle');

  links.forEach(link => {
    link.addEventListener('click', () => {
      const id = (link.getAttribute('href') || '').replace(/^#/, '');

      if (id) {
        setActive(id);
      }

      if (mobileToggle?.checked) {
        mobileToggle.checked = false;
      }
    });
  });

  if (!('IntersectionObserver' in window)) {
    return;
  }

  const observer = new IntersectionObserver(
    entries => {
      const visible = entries
        .filter(entry => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

      if (visible[0]?.target?.id) {
        setActive(visible[0].target.id);
      }
    },
    {
      rootMargin: '-20% 0px -55% 0px',
      threshold: [0.1, 0.25, 0.5],
    }
  );

  topics.forEach(topic => observer.observe(topic));
})();
